import { gql } from "@apollo/client";

export const GENERATE_API_KEY = gql`
  mutation ($name: String!, $scopes: [String]!) {
    generateApiKey(name: $name, scopes: $scopes) {
      apiKey {
        id
        key
        name
        scopes
        isActive
        createdAt
        lastUsedAt
      }
      secret
    }
  }
`;

export const DEACTIVATE_API_KEY = gql`
  mutation ($apiKeyId: ID!) {
    deactivateApiKey(apiKeyId: $apiKeyId) {
      success
    }
  }
`;
